export default __webpack_public_path__ + "static/shocked_jatin-a7dd6dbfacd05d7bf4cdb41eacca32cf.svg";